import { msalStatusSlice } from './msalStatus-slice';

export const { setResponseLoading, setSsoSilentStatus, setOpenRefreshTokenModal } = msalStatusSlice.actions;
export default msalStatusSlice;
